import {
	IconSize50,
	IconSize75,
	IconSize100,
	IconSize150,
	IconSize200,
	IconSize300,
	IconSize400,
	IconSize500,
	IconSize625,
	IconSize750,
} from "@mv/design-tokens/variables";
import { type SVGProps } from "react";
export interface Props
	extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
	size?:
		| "50"
		| "75"
		| "100"
		| "150"
		| "200"
		| "300"
		| "400"
		| "500"
		| "625"
		| "750";
}
const sizeMap = {
	50: IconSize50,
	75: IconSize75,
	100: IconSize100,
	150: IconSize150,
	200: IconSize200,
	300: IconSize300,
	400: IconSize400,
	500: IconSize500,
	625: IconSize625,
	750: IconSize750,
};
export default function IconUserBlack({ size = "100", ...props }: Props) {
	return (
		<svg
			xmlns={"http://www.w3.org/2000/svg"}
			{...props}
			viewBox="0 0 24 24"
			width={sizeMap[size]}
			height={sizeMap[size]}
		>
			<g fill="none" fillRule="nonzero">
				<path
					fill="#E42822"
					d="M7.81 16.131a.393.393 0 1 1-.787 0 .393.393 0 0 1 .786 0m9.167 0a.393.393 0 1 1-.786 0 .393.393 0 0 1 .786 0m-4.452.786a.393.393 0 1 1-.786 0 .393.393 0 0 1 .786 0"
				/>
				<path
					fill="#080A08"
					d="M3.4 6.652c-.358.618-.494 1.271-.3 1.913.238.784.886 1.375 1.788 1.816a6.7 6.7 0 0 0 1.42.5.378.378 0 1 0 .148-.743 5.932 5.932 0 0 1-1.234-.437c-.731-.356-1.23-.812-1.395-1.355-.125-.414-.032-.863.23-1.316.177-.307.444-.61.525-.664.353-.234.557-.641.305-1.057-.17-.285-.49-.352-.87-.285-.275.05-.604.176-.948.36-.446.24-.997.79-1.396 1.454a4.6 4.6 0 0 0-.64 2.948c.129 1.079.701 2.01 1.6 2.77a7.3 7.3 0 0 0 2.436 1.331.38.38 0 0 0 .451-.535.38.38 0 0 0-.222-.186 6.5 6.5 0 0 1-2.175-1.186c-.761-.644-1.232-1.411-1.336-2.283a3.84 3.84 0 0 1 .537-2.47c.332-.551.786-1.005 1.105-1.176a2.8 2.8 0 0 1 .675-.273c-.193.157-.494.51-.704.874m17.171-.601c.319.171.773.625 1.104 1.176.44.73.645 1.567.538 2.47-.104.872-.575 1.639-1.337 2.283a6.5 6.5 0 0 1-2.174 1.186.378.378 0 1 0 .229.721 7.3 7.3 0 0 0 2.436-1.33c.899-.76 1.471-1.692 1.6-2.771a4.6 4.6 0 0 0-.64-2.948c-.4-.663-.95-1.214-1.396-1.453-.345-.185-.673-.311-.949-.36-.38-.068-.698-.001-.87.284-.251.416-.047.822.306 1.057.081.054.347.357.525.664.262.453.355.902.23 1.316-.165.542-.664.998-1.396 1.355a6 6 0 0 1-1.233.437.378.378 0 1 0 .147.742 6.682 6.682 0 0 0 1.42-.5c.903-.44 1.55-1.031 1.788-1.815.195-.642.059-1.295-.298-1.913-.211-.364-.512-.718-.705-.874.182.04.419.135.675.273"
				/>
				<path
					fill="#080A08"
					d="M4.99 16.076q.029.042.097.125.104.127.26.273c.29.27.664.537 1.132.784 1.307.69 3.099 1.1 5.445 1.1 2.422 0 4.303-.409 5.709-1.095a6 6 0 0 0 1.226-.775q.171-.144.29-.269.075-.08.105-.12l.079-.103v-2.135c0-1.07-.58-2.648-1.581-3.877-1.347-1.654-3.32-2.627-5.898-2.627-2.597 0-4.47 1.024-5.662 2.763-.83 1.209-1.263 2.723-1.263 3.741v2.12zm.698-2.215c0-.87.39-2.235 1.13-3.312 1.054-1.537 2.694-2.433 5.036-2.433 2.344 0 4.104.867 5.309 2.347.892 1.096 1.41 2.506 1.41 3.398v1.86a3 3 0 0 1-.201.185 5.3 5.3 0 0 1-1.072.676c-1.299.633-3.067 1.016-5.376 1.016-2.227 0-3.896-.381-5.09-1.011a4.5 4.5 0 0 1-.968-.667 2 2 0 0 1-.178-.183z"
				/>
				<path
					fill="#080A08"
					d="M4.99 13.975q.027.044.095.126.104.128.259.275c.286.271.658.539 1.125.786 1.302.69 3.096 1.1 5.455 1.1 2.421 0 4.302-.408 5.707-1.095.501-.244.907-.508 1.227-.776q.17-.143.289-.269.075-.08.106-.12a.387.387 0 0 0-.066-.54.377.377 0 0 0-.533.067l-.007.009-.048.052a3 3 0 0 1-.226.21 5.3 5.3 0 0 1-1.072.675c-1.298.635-3.067 1.019-5.377 1.019-2.24 0-3.914-.383-5.103-1.013a4.4 4.4 0 0 1-.96-.667 2 2 0 0 1-.234-.258.377.377 0 0 0-.526-.113.387.387 0 0 0-.111.532"
				/>
				<path
					fill="#080A08"
					d="M12.262 14.047V6.953a.387.387 0 0 0-.393-.382.387.387 0 0 0-.393.382v7.094c0 .21.176.382.393.382s.393-.171.393-.382"
				/>
			</g>
		</svg>
	);
}
